import dynamic from 'next/dynamic';
import { RoomRequestsProps } from './RoomRequests.types';

export const RoomRequests = dynamic<RoomRequestsProps>(() =>
  import('./RoomRequests').then(module => module.RoomRequests)
);
